import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MenuPage from "../pages/menu/page";
import AboutPage from "../pages/about/page";
import AccessPage from "../pages/access/page";
import ReservationPage from "../pages/reservation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/menu",
    element: <MenuPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/access",
    element: <AccessPage />,
  },
  {
    path: "/reservation",
    element: <ReservationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;